import { gql, useQuery } from '@apollo/client';
import { SyndicateTypeEnumType } from '__generated__/graphql';
import classNames from 'classnames';
import { FC } from 'react';
import { useParams } from 'react-router-dom';

const GET_SYNDICATE_TYPE_QUERY = gql(`
  query GetSyndicateTypeForInviteTabs($id: ID!) {
    syndicate(id: $id) {
      id
      type
    }
  }
`);

const DealTabsForInvites: FC<{ activeTab: string; onSelect: (tab: string) => void }> = ({
  activeTab,
  onSelect,
}) => {
  const { syndicateId } = useParams<{ syndicateId: string }>();
  const { data } = useQuery(GET_SYNDICATE_TYPE_QUERY, {
    variables: { id: syndicateId },
  });

  const isRuv = data?.syndicate?.type === SyndicateTypeEnumType.Ruv;

  const tabs = [
    {
      title: 'Manage Invites',
      url: 'manage-invites',
      description: 'View details of your current invites',
    },
    ...(!isRuv
      ? [
          {
            title: 'Invite your network',
            url: 'invite-network',
            description: 'Send deal invites via email',
          },
        ]
      : []),
    {
      title: 'Invite Links',
      url: 'invite-links',
      description: 'Create an easily shareable link',
    },
  ];

  function isPathActive(path: string) {
    return activeTab === path;
  }

  return (
    <div className="sticky top-20">
      <nav>
        <ol className="flex gap-2 overflow-x-auto pb-1">
          {tabs.map(tab => (
            <li key={tab.url} className="shrink-0">
              <button
                onClick={() => onSelect(tab.url)}
                className={classNames(
                  'rounded-2xl border px-4 py-2.5 text-left transition-colors',
                  {
                    'border-indigo-600 bg-indigo-50 text-indigo-700 pointer-events-none':
                      isPathActive(tab.url),
                    'border-gray-300 bg-white text-gray-700 hover:bg-gray-50': !isPathActive(
                      tab.url
                    ),
                  }
                )}
              >
                <span className="block text-sm font-medium">{tab.title}</span>
                <span
                  className={classNames('block text-xs mt-0.5', {
                    'text-indigo-600/80': isPathActive(tab.url),
                    'text-gray-500': !isPathActive(tab.url),
                  })}
                >
                  {tab.description}
                </span>
              </button>
            </li>
          ))}
        </ol>
      </nav>
    </div>
  );
};

export default DealTabsForInvites;
